























































































import Vue from 'vue';
import Component from 'vue-class-component';
import RegisterAvailabilityForm from '@/modules/reports/management/components/RegisterAvailabilityForm.vue';
import { layout, reportsManagement } from '@/modules/shared/shared/store/namespaces';
import { ReportsInformation } from '@/modules/reports/management/domain/reports-information';
import * as rules from '@/modules/shared/shared/domain/rules';
import { BuildingDatacenter } from '@/modules/reports/management/domain/building-datacenter';
import { setLongFormatDate } from '@/modules/shared/shared/domain/functions/date-functions';
import { Watch } from 'vue-property-decorator';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';
import moment from 'moment';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { LayoutTitle } from '@/modules/shared/layouts/domain/layout-title';
import { ReportsManagementActions } from '@/modules/reports/management/store/reports-management.actions';
import { ReportRegistryView } from '@/modules/reports/management/domain/report-registry.view';
import { EquipmentAvailability } from '@/modules/reports/management/domain/equipment-availability';
import { ReportsManagementGetters } from '@/modules/reports/management/store/reports-management.getters';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { AvailabilityRegistryView } from '@/modules/reports/management/domain/availability-registry.view';

@Component({
    name: 'availability-registry',
    components: { SectionTitle, RegisterAvailabilityForm },
})
export default class AvailabilityRegistry extends Vue {
    rules: any = rules;

    $refs!: {
        form: any;
    };

    selectedLocation: ReportsInformation | null = null;

    selectedDatacenter: BuildingDatacenter | null = null;

    dateMenu: boolean = false;

    isLoading: boolean = false;
    isFetchingData: boolean = false;

    date: string = setLongFormatDate(
        moment()
            .toISOString(true)
            .substr(0, 10),
    );
    pickerDate: string = moment()
        .toISOString(true)
        .substr(0, 10);
    hour: string | null = `${moment().hour()}:00`;

    reset() {
        this.selectedLocation = null;
        this.selectedDatacenter = null;
        this.hour = `${moment().hour()}:00`;
        this.$refs.form.reset();
        this.$nextTick(() => {
            this.date = setLongFormatDate(
                moment()
                    .toISOString(true)
                    .substr(0, 10),
            );
            this.pickerDate = moment()
                .toISOString(true)
                .substr(0, 10);
        });
    }

    get availableDatacenters() {
        if (this.selectedLocation) {
            return this.selectedLocation.buildingsDataCenters;
        }
        return [];
    }

    async mounted() {
        this.changeTitle({ title: 'Disponibilidad', route: ['Registro'] });
        this.isFetchingData = true;
        const failed = await this.fetchView();
        if (failed) {
            (failed as ExceptionMessage).showError();
        }
        this.isFetchingData = false;
    }

    dateInputted(date: string) {
        this.date = setLongFormatDate(date);
    }

    async register(params: {
        success: boolean;
        equipmentsData: { [key: string]: { id: number; value: string } }[];
    }) {
        if (!this.$refs.form.validate() || !params.success) {
            EventBus.$emit(EventBusMessages.SHOW_ERROR, 'Hay campos pendientes por completar');
        } else {
            this.isLoading = true;
            const failed = await this.createReport({
                equipmentsData: params.equipmentsData,
                date: `${this.pickerDate} ${this.hour}`,
            });
            if (!failed) {
                EventBus.$emit(
                    EventBusMessages.SHOW_SUCCESS,
                    'Se han creado los reportes con éxito',
                );
            } else {
                (failed as ExceptionMessage).showError();
            }
            this.reset();
            this.isLoading = false;
        }
    }

    @Watch('selectedLocation')
    onSelectedLocationChanged() {
        this.selectedDatacenter = null;
    }

    @reportsManagement.Action(ReportsManagementActions.FETCH_AVAILABILITY_REGISTRY_DATA)
    fetchView!: () => Promise<RequestResponse>;

    @reportsManagement.Getter(ReportsManagementGetters.GET_AVAILABILITY_REGISTRY_DATA)
    view!: AvailabilityRegistryView;

    @reportsManagement.Action(ReportsManagementActions.CREATE_AVAILABILITY_REPORT)
    createReport!: (params: {
        equipmentsData: EquipmentAvailability[];
        date: string;
    }) => Promise<RequestResponse>;

    @layout.Mutation(LayoutMutations.CHANGE_TITLE)
    changeTitle!: (layout: LayoutTitle) => void;
}
